export const globalDomains: Record<string, string> = {
	confluence: 'confluence.atlassian.com', // Atlassian design system documentation
	design: 'design.atlassian.com', // Atlassian design system documentation
	extranet: 'extranet.atlassian.com', // Old staff intranet (now hello.atlassian.net)
	go: 'go.atlassian.com', // Go links
	my: 'my.atlassian.com',
	surveys: 'surveys.atlassian.com',
	'wac-cdn': 'wac-cdn.atlassian.com', // WAC CDN links
	integrations: 'integrations.atlassian.com', // Integrations links
	permalink: 'permalink.atlassian.com',
	support: 'support.atlassian.com',
};
